import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Alert, Button, Card, CardBody, CardGroup, Col, Container,
    Input, InputGroup, InputGroupAddon, InputGroupText, Row, FormGroup, Label, CardImg,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap';
import IntlTelInput from 'react-intl-tel-input';
import { login, suspendAccount, } from '../../../api/Login'
import * as actions from '../../../actions';
import { Redirect, Switch } from 'react-router-dom';
import { signUpUserEntry, signupvarifyphone, duplicatedUser } from '../../../api/SignUp';
import { ChangeUserStatus } from "../../../api/User";
import 'react-intl-tel-input/dist/main.css';
import Dropzone from 'react-dropzone';
import { Cropper } from 'react-image-cropper';
import { LoadingSpinner } from '../../../components';
import Countdown from 'react-countdown';
import CompanyEntryList from './CompanyEntryList';
import Dashboard from '../../Dashboard/Dashboard';

class NewCompanyEntryDetail extends Component {
    static routeName = '/info/company-new';
    constructor(props) {
        super(props);
        this.state = {
            changeScreen: false,
            successMessage: "",
            errorMessage: "",
            loginId: "",
            displayName: "",
            password: "",
            newPassword: "",
            confirmPassword: "",
            attempts: 0,
            rowKey: 0,
            attemptsMessge: "",
            timestamp: undefined,
            userId: "",
            email: "",
            phoneNo: "",
            isActive: true,
            isLoading: false,
            isTimeout: false,
            messageVisible: false,
            isNewCompany: true,
        }
    };
    updateState(prop, value) {
        if (prop === "loginId") this.setState({ attempts: 0 })
        this.setState({
            [prop]: value
        })
    }
    validateChangePassword() {
        if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({
                errorMessage: "password do not match"
            })
            return false;
        } if (this.state.newPassword === "" || this.state.confirmPassword === "") {
            this.setState({
                errorMessage: "all fields must be fill"
            })
            return false;
        }

        return true
    }
    validate() {
        let { displayName, loginId, password, confirmPassword } = this.state;
        if (password !== confirmPassword && confirmPassword !== "") {
            this.setState({
                errorMessage: "password do not match"
            })
            return false;
        } if (displayName === "" || loginId === "" || password === "" || confirmPassword === "") {
            this.setState({
                errorMessage: "all fields must be fill"
            })
            return false;
        }

        return true;
    }


    async submitHandle() {
        if (this.validate() === false) return;
        this.setState({ isLoading: true, errorMessage: "" });
        let varifyphone = "";
        let Response_duplicatedUser = await duplicatedUser(this.state.loginId);
        if (Response_duplicatedUser.data.status) {
            varifyphone = await signupvarifyphone(this.state.loginId); //OTP verify phone number
            //input user is already existed in DB
            if (varifyphone.status === false) {
                this.setState({ errorMessage: varifyphone.message, isLoading: false });
            } else {
                this.handleSubmit();
            }

        } else {
            this.setState({ isLoading: false, errorMessage: "This User is already existed" });
        }
    }

    async handleSubmit() {
        this.setState({ isLoading: true });
        let res = await signUpUserEntry(this.state);
        if (res.status) {
            this.setState({ isLoading: false, successMessage: res.message, messageVisible: true},()=>this.handleReset());
        } else {
            this.setState({
                errorMessage: res.message,
                attemptsMessge: "",
                isLoading: false,
                phoneNo: "",
                loginId: "",
                displayName: "",
                password: "",
                confirmPassword: ""
            });
        }
    }

    async handleReset() {
            this.setState({
                attemptsMessge: "",
                phoneNo: "",
                loginId: "",
                displayName: "",
                password: "",
                confirmPassword: ""
            });
    }





    ToCompanyList() {
        this.props.history.push({ pathname: CompanyEntryList.routeName })
    }



    render() {
        return (
            <Container>
                {this.state.isLoading && <LoadingSpinner />}

                <Row>
                    <Col md="6">
                        <CardGroup>
                            <Card className="p-4">
                                <CardBody>
                                    <form action="">
                                        <h3>New Company</h3><br />

                                        <InputGroup className="mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="fa fa-phone"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input autoFocus="autofocus" type="text" name="loginId" value={this.state.loginId} onChange={(e) => this.updateState("loginId", e.target.value)} placeholder="Phone Number" />
                                        </InputGroup>

                                        <InputGroup className="mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="fa fa-user-o"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="text" name="displayName" value={this.state.displayName} onChange={(e) => this.updateState("displayName", e.target.value)} placeholder="Name" />
                                        </InputGroup>


                                        <InputGroup className="mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="fa fa-lock fa-lg"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="password" name="password" value={this.state.password} onChange={(e) => this.updateState("password", e.target.value)} placeholder="Password" />
                                        </InputGroup>


                                        <InputGroup className="mb-4">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="fa fa-check-circle-o"></i>
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input type="password" name="confirmpassword" value={this.state.confirmPassword} onChange={(e) => this.updateState("confirmPassword", e.target.value)} placeholder="Confirm Password" />
                                        </InputGroup>

                                        {this.state.errorMessage !== "" &&
                                            <Alert color="danger">{this.state.errorMessage}</Alert>
                                        }

                                        <Row>
                                            <Col xs="6">
                                                <Button color="primary" className="px-4" type="button" onClick={() => this.ToCompanyList()
                                                }>Cancel</Button>
                                            </Col>
                                            <Col xs="6" className="text-right">
                                                <Button color="primary" className="px-4" type="button" onClick={() => this.submitHandle()
                                                }>Sign Up</Button>
                                            </Col>
                                        </Row>
                                    </form>
                                    {this.state.successMessage !== "" &&
                                        <Alert color="success" isOpen={this.state.messageVisible} toggle={() => this.setState({ messageVisible: false })}>
                                            <span>{this.state.successMessage}<br /></span>
                                        </Alert>
                                    }
                                </CardBody>
                            </Card>

                        </CardGroup>
                    </Col>
                </Row>
            </Container>
        );
    }
}
function mapStateToProps(state) {
    return { auth: state.auth };
}

export default connect(mapStateToProps, actions)(NewCompanyEntryDetail);
